import store from "@frameworks/web/redux/store";
import { DIVERSIFY_PORTFOLIO, DIVERSIFY_PORTFOLIO_ERROR, DIVERSIFY_PORTFOLIO_HIDE_ERROR, DIVERSIFY_PORTFOLIO_START_LOADER, DIVERSIFY_PORTFOLIO_STOP_LOADER, } from "../interface/IDiversifyPortfolio";
class DiversifyPortfolioActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getDiversifyPortfolio(data) {
        this.dispatch({
            type: DIVERSIFY_PORTFOLIO,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: DIVERSIFY_PORTFOLIO_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: DIVERSIFY_PORTFOLIO_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: DIVERSIFY_PORTFOLIO_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: DIVERSIFY_PORTFOLIO_STOP_LOADER,
        });
    }
}
export default DiversifyPortfolioActions;
